"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _vueRouter = require("vue-router");

var _Home = _interopRequireDefault(require("@/views/Home.vue"));

var _HealthCheck = _interopRequireDefault(require("@/views/HealthCheck.vue"));

var _NotFoundPage = _interopRequireDefault(require("@/views/NotFoundPage.vue"));

var routes = [{
  path: '/',
  name: 'Home',
  component: _Home.default
}, {
  path: '/health',
  name: 'health',
  component: _HealthCheck.default
}, {
  path: '/:pathMatch(.*)*',
  name: 'Página no encontrada',
  component: _NotFoundPage.default
}];
var router = (0, _vueRouter.createRouter)({
  history: (0, _vueRouter.createWebHistory)(process.env.BASE_URL),
  routes: routes
});
var _default = router;
exports.default = _default;